import {
  TOnError,
  TOnFile,
  TOnUpdateFiles,
} from "components/ProjectNonSpecificComponents/Elements/UploadButton/Interfaces";
import { ACCEPTED_ATTACHMENT_EXT_AND_MIME_TYPES } from "components/ProjectSpecificComponents/Constants/GLOBAL_CONSTANTS";
import mapValuesOrKeysFromObject from "components/ProjectSpecificComponents/Functions/mapValuesOrKeysFromObject";
import React from "react";
import UploadButton from "../../../../../ProjectNonSpecificComponents/Elements/UploadButton/UploadButton";
import IconButton from "./IconButton";

interface Props {
  files?: File[];
  disabled?: boolean;
  onFile?: TOnFile;
  onUpdateFiles?: TOnUpdateFiles;
  onError?: TOnError;
}

const AttachmentButton = ({
  files,
  disabled,
  onFile,
  onUpdateFiles,
  onError,
}: Props) => {
	const mimeExt: string[] = mapValuesOrKeysFromObject(ACCEPTED_ATTACHMENT_EXT_AND_MIME_TYPES, false)
  return (
    <UploadButton
      files={files}
      disabled={disabled}
      onFile={onFile}
      onUpdateFiles={onUpdateFiles}
      onError={onError}
			accept={mimeExt}
    >
      <IconButton iconKey="attachment" disabled={disabled} />
    </UploadButton>
  );
};

export default AttachmentButton;
